'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'house-chimney';
var width = 512;
var height = 512;
var aliases = [63499,"home-lg"];
var unicode = 'e3af';
var svgPathData = ['M48 267.7c2-1.2 4-2.6 5.8-4.3L256 75.7 458.2 263.4c1.8 1.7 3.7 3.1 5.8 4.3L464 448c0 35.3-28.7 64-64 64l-80 0 0-128c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48l0 128-80 0c-35.3 0-64-28.7-64-64l0-180.3z', 'M234.2 8.6c12.3-11.4 31.3-11.4 43.5 0L368 92.3 368 80c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 101.5 37.8 35.1c13 12 13.7 32.3 1.7 45.2s-32.3 13.7-45.2 1.7L256 75.7 53.8 263.4c-13 12-33.2 11.3-45.2-1.7s-11.3-33.2 1.7-45.2l224-208zM192 384c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 128-128 0 0-128z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHouseChimney = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;